import { createContext, useContext } from "react";

import { EncounterExistsPromptHelper } from "./EncounterExistsPromptHelper.ts";

export const EncounterExistsPromptContext =
  createContext<EncounterExistsPromptHelper>({} as EncounterExistsPromptHelper);
export const useEncounterExistsPromptContext = () =>
  useContext(EncounterExistsPromptContext);
